import { BulkMoveDialog } from "@/action-dialog/dialogs/BulkMoveDialog";
import type { UnifiedItem } from "@/pages/workspaces/types";
import type { FileRecord } from "@cohesive/api-client";
import { useRef } from "react";
import { createCallable } from "react-call";

const UNMOUNTING_DELAY_MS = 200;

export type BulkMoveCallableProps = {
  workspaceId: string;
  allRecords: FileRecord[];
  items: UnifiedItem[];
};

export const BulkMoveCallable = createCallable<BulkMoveCallableProps, boolean>(
  ({ call, workspaceId, allRecords, items }) => {
    const succeededRef = useRef(false);

    return (
      <BulkMoveDialog
        workspaceId={workspaceId}
        allRecords={allRecords}
        items={items}
        onClose={() => {
          call.end(succeededRef.current);
          succeededRef.current = false;
        }}
        onSuccess={() => {
          succeededRef.current = true;
        }}
      />
    );
  },
  UNMOUNTING_DELAY_MS,
);

BulkMoveCallable.displayName = "BulkMoveCallable";
